export default {
  tomorrow: {
    get () {
      const date = new Date()
      date.setDate(date.getDate() + 1) // add one day
      return date.toISOString().slice(0, 10)
    }
  },
  one_year_later: {
    get () {
      const date = new Date()
      date.setFullYear(date.getFullYear() + 1) // add one year
      return date.toISOString().slice(0, 10)
    }
  },
  releaseDateErrors() {
    return Object.keys(this.errors)
      .filter(error => error.includes('release date'))
      .map(error => this.errors[error])
  },
  confirmation_heading: {
    get () {
      const declaration = this.$sanitize(this.$t(`pages.submissions.components.confirmation.${this.credibility ? 'credibility.declaration' : 'please_review'}`))
      return declaration
    }
  },
  date_heading: {
    get () {
      const approval = this.$sanitize(this.$t(`pages.submissions.components.confirmation.${this.credibility ? 'credibility.after_approval' : 'after_approval'}`))
      return approval
    }
  },
  textarea_desc: {
    get () {
      const note = this.$sanitize(this.$t(`pages.submissions.components.confirmation.${this.credibility ? 'credibility.note' : 'have_questions'}`))
      return note
    }
  }
}
